import classNames from 'classnames';
import { useAiMetadata } from 'contexts/AIMetadataProvider';
import { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { showDeferredToast } from 'utils/deferredToast';

const ToastContainerWithOffset = () => {
  const { toastOffset } = useAiMetadata();
  const opacityThreshold = window?.innerHeight * 0.8 || 0;

  useEffect(() => {
    showDeferredToast();
  }, []);

  return (
    <ToastContainer
      toastClassName={() => 'p-0'}
      className={classNames('p-0 bg-none transition-opacity', {
        'transition-[bottom]': toastOffset === 0,
        'opacity-0': toastOffset > opacityThreshold,
      })}
      style={{ bottom: toastOffset }}
    />
  );
};

export default ToastContainerWithOffset;
